<template>
    <div class="ma-0 use-container">
        <v-img
            class="d-flex align-center use-banner"
            :src="
                $vuetify.breakpoint.smAndUp
                    ? require(`@/assets/bg/where-to-use-md.jpg`)
                    : require(`@/assets/bg/where-to-use-xs.png`)
            "
        >
            <div class="top-content page-content use-title-wrapper">
                <div class="use-title-group">
                    <p class="use-title font-weight-bold">
                        Where to Use
                    </p>
                    <p class="use-subtitle">
                        Nexon Game Card is accepted by the game titles and
                        publishers listed below. Plus, we’re adding more, so
                        keep your eyes peeled. Want to know who and when? Join
                        our mailing list at the bottom of the page.
                    </p>
                </div>
            </div>
        </v-img>
        <section class="search-section">
            <div class="search-wrapper">
                <search-bar @input="search = $event"></search-bar>
            </div>
        </section>
        <section class="partners-section">
            <v-img
                class="right-shape-image"
                src="../assets/dots-diamond.svg"
            ></v-img>
            <v-img
                class="left-shape-image"
                src="../assets/dots-diamond.svg"
            ></v-img>
            <div class="page-content">
                <v-container class="partners-list-container pa-0">
                    <v-col cols="12" class="pa-0">
                        <v-row class="select-publisher-section">
                            <span>Select Publisher:</span>
                            <select-publisher
                                @input="selectedPublisher = $event"
                            ></select-publisher>
                        </v-row>
                        <v-slide-y-reverse-transition>
                            <partners-list
                                :nameFilter="search"
                                :publisherFilter="selectedPublisher"
                            ></partners-list>
                        </v-slide-y-reverse-transition>
                    </v-col>
                </v-container>
            </div>
        </section>
    </div>
</template>

<script>
import searchBar from '@/components/Partners/search-bar';
import partnersList from '@/components/Partners/partners-list';
import selectPublisher from '@/components/Partners/select-publisher';
export default {
    name: 'partners',
    data: () => ({
        search: '',
        selectedPublisher: 'All',
        searchTimeout: undefined,
        isIE11Browser: /Trident.*rv[ :]*11\./.test(navigator.userAgent),
    }),
    components: { searchBar, partnersList, selectPublisher },
    metaInfo() {
        return {
            titleTemplate: `%s | Where To Use`,
        };
    },
    created() {
        this.$store.dispatch('fetchPartners');
    },
    watch: {
        search() {
            if (this.searchTimeout) {
                window.clearTimeout(this.searchTimeout);
            }
            this.searchTimeout = window.setTimeout(() => {
                window.dataLayer.push({
                    event: 'Game Search',
                    'game search query': this.search,
                });
            }, 2000);
        },
    },
};
</script>
<style lang="scss" scoped>
.use-container {
    background-color: #fafafa;
    .use-banner {
        position: relative;

        // EDGE ONLY HACK
        @supports (-ms-ime-align: auto) {
            display: -webkit-box !important;
        }

        .use-title-wrapper {
            position: relative;
            min-height: 460px;
            display: flex;
            justify-content: center;
            .use-title-group {
                margin-top: 30px;
                color: #212843;
                .use-title {
                    font-size: 36px;
                    margin-bottom: 10px;
                    line-height: 1;
                    font-family: KlavikaNX-Medium, serif;
                    text-transform: uppercase;
                }
                .use-subtitle {
                    font-size: 16px;
                    margin-bottom: 0;
                    line-height: 1.38;
                    max-width: 400px;
                }
            }
        }
    }

    .search-section {
        position: relative;
        .search-wrapper {
            margin: 0;
        }
    }

    .partners-section {
        position: relative;
        overflow: hidden;
        width: 100vw;
        min-width: 360px;
        max-width: 100%;
        height: 100%;
        min-height: 858px;
        margin-bottom: 60px;
        .right-shape-image {
            position: absolute;
            width: 156px;
            top: 35%;
            right: -78px;
            transform: rotate(-90deg);
        }
        .left-shape-image {
            position: absolute;
            width: 156px;
            top: 65%;
            left: -78px;
            transform: rotate(90deg);
        }
        .partners-list-container {
            max-width: 318px;
            .select-publisher-section {
                margin-bottom: 10px;
                min-width: 264px;
                justify-content: center;
                span {
                    font-size: 16px;
                }
            }
        }
    }
}
.v-btn {
    height: 0;
}

@include break('xs') {
    .use-subtitle {
        padding: 0 4px;
        text-align: justify;
    }
    .use-title {
        text-align: center;
    }
}

@include break('sm') {
    .use-container .use-banner .use-title-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .use-title-group {
            text-align: left;
            margin: 0 auto 20px 30px;
            .use-title {
                font-size: 42px;
                margin-bottom: 25px;
                text-align: left;
            }
            .use-subtitle {
                font-size: 16px;
            }
        }
    }
    .use-container .search-section .search-wrapper {
        margin: 0 30px;
    }
    .use-container .partners-section {
        .partners-list-container {
            max-width: 390px;
        }
    }
}
@include break('md') {
    .use-container .use-banner .use-title-wrapper {
        width: calc(100vw - 76px); // 30px margin on each side + 16px scroll bar
        .use-title-group {
            margin-left: 55px;
            .use-title {
                font-size: 50px;
            }
        }
    }
    .use-container .search-section .search-wrapper {
        margin: 0 58px;
    }
    .use-container .partners-section {
        margin-bottom: 80px;
        .partners-list-container {
            max-width: 780px;
            .select-publisher-section {
                justify-content: start;
                margin-left: 10px;
            }
        }
    }
}
@include break('lg') {
    .use-container .use-banner .use-title-wrapper {
        width: calc(
            100vw - 132px
        ); // 58px margin on each side + 16px scroll bar
        .use-title-group {
            margin-left: 100px;
            .use-title {
                font-size: 60px;
            }
            .use-subtitle {
                font-size: 20px;
                max-width: 500px;
                line-height: 1.5;
            }
        }
    }
    .use-container .partners-section {
        .partners-list-container {
            max-width: 1170px;
        }
    }
}
@include break('xl') {
    .use-container .search-section {
        margin: 0 auto;
        .search-wrapper {
            margin: 0 auto;
            max-width: 1560px;
        }
    }
    .use-container .partners-section {
        .partners-list-container {
            max-width: 1560px;
        }
    }
}
@media (max-width: 1920px) {
    .use-container .partners-section .partners-list-container {
        max-width: 1560px;
    }
}

@media (max-width: 1576px) {
    .use-container .partners-section .partners-list-container {
        max-width: 1170px;
    }
}
@media (max-width: 1250px) {
    .use-container .partners-section .partners-list-container {
        max-width: 780px;
    }
}

@media (max-width: 796px) {
    .use-container .partners-section .partners-list-container {
        max-width: 320px;
    }
}
</style>
